module.exports = __webpack_public_path__ + "img/AndroidTV_X8500F.f828e1a4.png";